// import serviceTokenNew from '../../services/requestTokenNew';
// const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;
import serviceToken from '../../services/requestToken';
const RETAILER_API_URL = process.env.REACT_APP_RETAILER_BASE_API;

/**
 * @description create tickets
 */
export const createOrderMessageApi = async (reqBody) => {
  // return serviceTokenNew({
  //   url: `${API_GATEWAY_URL}privateauthservice/ticketingservice/v1/admin/tickets`,
  //   method: 'post',
  //   data,
  //   isTicketApi: true
  // });
  if (reqBody == null) throw new Error('Request body is required');
  const { status, data } = await serviceToken.post(
    `${RETAILER_API_URL}customer-service/tickets/`,
    reqBody
  );
  if (status !== 200 || data?.data == null)
    throw new Error(data.message || 'Failed to create order message');
  return data.data;
};

/**
 * @description getting all messages of an order
 * @param {string} order_id
 */
export const getOrderMessageApi = async (orderId) => {
  // return serviceTokenNew({
  //   url: `${API_GATEWAY_URL}privateauthservice/ticketingservice/v1/admin/tickets/orders/${orderId}/messages`,
  //   method: 'get',
  //   isTicketApi: true
  // });
  if (orderId == null) throw new Error('Order ID is required');
  const { status, data } = await serviceToken.get(
    `${RETAILER_API_URL}customer-service/tickets/orders/${orderId}/messages`
  );
  if (status !== 200 || data?.data == null)
    throw new Error(data.message || 'Failed to get order messages');
  return data.data;
};

/**
 * @description send a message
 * @param {string} order_id
 */
export const sendOrderMessageApi = async (orderId, reqBody) => {
  // return serviceTokenNew({
  //   url: `${API_GATEWAY_URL}privateauthservice/ticketingservice/v1/admin/tickets/orders/${orderId}/messages`,
  //   method: 'post',
  //   data,
  //   isTicketApi: true
  // });
  if (orderId == null) throw new Error('Order ID is required');
  if (reqBody == null) throw new Error('Request body is required');
  const { status, data } = await serviceToken.post(
    `${RETAILER_API_URL}customer-service/tickets/orders/${orderId}/messages`,
    reqBody
  );
  if (status !== 200 || data?.data == null)
    throw new Error(data.message || 'Failed to send order message');
  return data.data;
};
